/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-lines */
/* eslint-disable react/jsx-handler-names */
/* eslint-disable react/jsx-boolean-value */
"use client";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../../components/atoms/breadCrumb";
import InfiniteScroll from "../../components/molecules/infiniteScroll";
import FilterSort from "../../components/organisms/filterSort";
import PlpTitleRowDesktop from "../../components/organisms/plpTitleRowDesktop";
import ProductCard from "../../components/organisms/productCard";
import ProductFilter from "../../components/organisms/productFilter";
import { COUNTRIES, fnpPageType, LOCAL_CURRENCY, TESTIMONIAL_TITLE } from "../../constants/common/common";
import { plpBannerConstants, plpCleverTapEvents, plpPageConstants } from "../../constants/pageConstants/plpConstants";
import { requestToAddListingDataAction, requestToFetchProductListingAction } from "../../store/slices/plpSlice";
import {
  buildPartnerMembershipFlags,
  debounce,
  formatClassNames,
  isJsonString,
  removeEmptyNullAndUndefinedFromObject,
  scrollToSection,
  throttle,
} from "../../utils/common/index";
import { setCatalogId, setIsMobile } from "../../store/slices/common/appConfig";
import { setIsLoaderVisible } from "../../store/slices/cartSlice";
import isEmpty from "lodash.isempty";
import Regex from "../../utils/regex";
import { hideElementsForPLP, showElementsForPLP } from "../../utils/document";
import useAnalytics from "../../analytics/useAnalytics";
import CookieUtil, { setCookieIfAbsent } from "../../utils/storage/cookieUtil";
import {
  HDFC_SMARTBUY,
  LAST_VISITED_ADDRESS,
  LAST_VISITED_INTERNATIONAL_CITY,
  LAST_VISITED_INTERNATIONAL_LOCATION,
  LAST_VISITED_PINCODE,
  PARTNER,
  SELECTED_INTERNATIONAL_CITY,
} from "../../constants/storage";
import { setGA4SelectedProduct, setGA4ViewItemList } from "../../analytics/gaEvents";
import { GA4_EVENTS } from "../../analytics/gaConstant";
import { getPageTypeFromURL, PageTypes, setListingPageType } from "../../utils/fnpPageType";
import { usePathname } from "next/navigation";
import { setIsMobileSearchVisibleAction } from "../../store/slices/commonSlice";
import useScrollVisibility from "../../customHooks/useScrollVisibility";
import QuickLinks from "../../components/molecules/quickLinks";
import PlpBanner from "./plpBanner/plpBanner"; //when adding skeleton make it dynamic import as well
import PLPBannerTile from "../../components/molecules/plpBannerTile"; //when adding skeleton make it dynamic import as well
import CarouselContainer from "../../components/molecules/carouselContainer";
import PlpTitleRowMobile from "../../components/organisms/plpTitleRowMobile";
import CountOnScroll from "../../components/organisms/countOnScroll";
import {
  setSelectedCountryAction,
  setSelectedDomesticLocation,
  setSelectedIntLocation,
} from "../../store/slices/locationLock";
import CleverTapWidget from "../../components/organisms/cleverTapWidget";
import { campaignEvents, duplicateCleverTapEvents } from "../../analytics/clevertapConstants";
import { initiateFus } from "../../store/slices/common/fus";
import { playMobilePlpVideo, getDisplayTags } from "../../utils/plp/common";
import { getProductsAttrTag } from "../../api/plpApi";
import { captureImpressions, clearCapturedImpressions } from "../../analytics/cdp/captureImpressions";
import LottieLoader from "../../components/atoms/lottieLoader";
import PlpSkeleton from "../../components/molecules/skeletons/plpSkeleton";
import useNavigationReset from "../../customHooks/useNavigationReset";
import { loadAccuracyWeightageOnIdle } from "../../api/common";
import usePlpExperimentResolve from "../../customHooks/usePlpExperimentResolve";
import FilterChips from "../../components/organisms/filters/filterChips";
import SingleImageBannerSection from "../homePage/homeComponents/SingleImageBannerSection";
import OccasionSpecialEffects from "../../components/molecules/occasionSpecialEffects";
import CursorManager from "../../components/atoms/cursorManager/index.";
import { requestToFetchInitialPlpServiceabilityAction } from "../../store/slices/earliestDeliveryDatesSlice";
import ClearCart from "../../components/organisms/clearCart";
import FreeDeliveryBannerWrapper from "../../components/molecules/freeDeliveryBanner/FreeDeliveryBannerWrapper";
import { useABTestingView } from "../../customHooks/clevertap/useABTestingView";
import { isPlpDeliveryTimeHidden } from "../../utils/plp/serviceabilityDelivery";

const CommonConditionalComponents = dynamic(() => import("../../components/molecules/commonConditionalComponents"), {
  ssr: false,
});
const OneTapLogin = dynamic(() => import("../../components/organisms/googleOneTapLogin"));
const ProductNotFoundWrapper = dynamic(() => import("../../components/organisms/productNotFound"));
const CustomerReviewsCarousel = dynamic(() => import("../../components/organisms/customerReviewsCarousel"));

/** PLP viewed is held back this long so the client experiment resolve call can land first. */
const PLP_PAGE_VIEWED_DELAY_MS = 500;

/**
 * Reads CMS listing widgets that may arrive as objects/arrays or leftover JSON strings.
 *
 * @param {unknown} value - CMS field
 * @returns {unknown|null} Parsed value, or null when empty/invalid
 */
const parseCmsClientField = (value) => {
  if (value == null || value === "") {
    return null;
  }
  if (typeof value === "object") {
    return value;
  }
  if (typeof value === "string" && isJsonString(value)) {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }
  return null;
};

/**
 * Product List Component
 * @returns {JSX.Element} Product List JSX
 */
export const ProductListingPage = ({
  fetchFromAPI,
  sortOption,
  reviewResponse,
  breadcrumbs,
  categoryBanner,
  plpBanners,
  plpPromotionalBanners,
  capsulesData,
  isMobile,
  categoryId,
  shortDescription,
  catalogId,
  isShowBreadCrumbs = true,
  searchQuery,
  userUUID,
  isPlpRevampTiles = false,
  serverSidePincode = "",
  freeBannerData,
  plpATF = "",
  serverSelectedCurrency = null,
}) => {
  useEffect(() => loadAccuracyWeightageOnIdle(), []);
  const parsedPromotionalBanners = parseCmsClientField(plpPromotionalBanners);
  const bannerTileData = Array.isArray(parsedPromotionalBanners) ? parsedPromotionalBanners : [];
  const parsedCapsulesData = parseCmsClientField(capsulesData);
  const hasCapsulePills = Array.isArray(parsedCapsulesData?.data) && parsedCapsulesData.data.length > 0;
  const parsedPlpBanners = parseCmsClientField(plpBanners);

  const dispatch = useDispatch();
  const pathname = usePathname();
  const { init, trackEvent } = useAnalytics();
  const [productsAttrTagData, setProductsAttrTagData] = useState({});

  // Fetch productsAttrTagResponse client-side
  useEffect(() => {
    /**
     * fetchProductsAttrTag - Fetch productsAttrTagResponse from the API
     */
    const fetchProductsAttrTag = async () => {
      try {
        const response = await getProductsAttrTag();
        if (response && !response.status) {
          setProductsAttrTagData(response);
        }
      } catch (error) {
        console.log("Error fetching productsAttrTag", error);
      }
    };

    fetchProductsAttrTag();
  }, []);

  const {
    data,
    facetDetailList,
    sortOptions,
    categoryRatingValue,
    categoryTotalReview,
    productCategoryName,
    total,
    totalPages: totalPage,
  } = fetchFromAPI || {};

  const {
    details,
    appliedFilters,
    appliedSort,
    pincode,
    domesticAddress,
    isUserLoggedIn,
    isLoaded,
    totalProducts,
    loginDetail,
    isShowMobileLocationLockDrawer,
    isShowMobileLocationLock,
    isCurrencyDrawerVisible,
    isMobileSearchDrawerVisible,
    intlPincode,
    deliveryDates,
    occasionSpecialEffect,
    emailID,
    isDateLoaded,
    fullBannerData,
    selectedCurrencyFromState,
    isShowCartEmpty,
  } = useSelector(
    (state) => ({
      details: state?.plp?.details || [],
      appliedFilters: state?.plp?.appliedFilters,
      appliedSort: state?.plp?.appliedSort,
      pincode: state?.locationLock?.selectedDomesticLocation?.pincode,
      domesticAddress: state?.locationLock?.selectedDomesticLocation?.address,
      isUserLoggedIn: state?.fus?.loginDetail?.loggedin,
      isLoaded: state?.plp?.isLoaded,
      totalProducts: state?.plp?.details?.total,
      loginDetail: state?.fus?.loginDetail,
      isShowMobileLocationLockDrawer: state?.locationLock?.isShowMobileLocationLockDrawer,
      isShowMobileLocationLock: state?.locationLock?.isShowMobileLocationLock,
      isCurrencyDrawerVisible: state?.currencyList?.isCurrencyDrawerVisible,
      isMobileSearchDrawerVisible: state?.common?.isMobileSearchDrawerVisible,
      intlPincode: state?.locationLock?.selectedIntLocation?.pincode,
      deliveryDates: state?.deliveryDate?.details?.deliveryDates,
      isDateLoaded: state?.deliveryDate?.isDateLoaded,
      occasionSpecialEffect: state?.webFeatureControls?.data?.occasionSpecialEffect,
      emailID: state?.loginSignUp?.userDetails?.emailID || "",
      fullBannerData: state?.webFeatureControls?.data?.plpPdpBanners,
      selectedCurrencyFromState: state?.currencyList?.userSelectedCurrency,
      isShowCartEmpty: state?.locationLock?.isShowCartEmpty,
    }),
    shallowEqual,
  );
  const isNavigating = useNavigationReset();
  // A/B (CleverTap deliveryTimeVisibility): "none" / "single" show day/date only on the cards (read once per page).
  const { deliveryTimeVisibility } = useABTestingView();
  const isCardDeliveryTimeHidden = isPlpDeliveryTimeHidden(deliveryTimeVisibility);

  // Experiment targeting is resolved in the browser instead of read from the SSR listing response,
  // which is CDN-cached and can carry another user's bucket. Search has no category url to resolve.
  const { campaignId, groupName, segmentId } = usePlpExperimentResolve({
    categoryUrl: !categoryId || categoryId === plpPageConstants?.SEARCH ? "" : `fnp.com/${categoryId}`,
    geoId: catalogId || COUNTRIES?.INDIA,
    email: emailID,
    userUUID,
  });

  const currency = serverSelectedCurrency || CookieUtil.getCookie(LOCAL_CURRENCY);
  const lastVisitedPincode = CookieUtil.getCookie(LAST_VISITED_PINCODE);
  const lastVisitedAddress = CookieUtil.getCookie(LAST_VISITED_ADDRESS);
  const selectedIntLocation = CookieUtil.getCookie(LAST_VISITED_INTERNATIONAL_LOCATION);
  const lastVisitedIntlCity = CookieUtil.getCookie(LAST_VISITED_INTERNATIONAL_CITY);
  const selectedIntlCity = CookieUtil.getCookie(SELECTED_INTERNATIONAL_CITY);

  const [plpBannerData, setPlpBannerData] = useState(null);
  const [impressionData, setImpressionData] = useState({});
  const [isProductClicked, setIsProductClicked] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [currencyValue, setCurrencyValue] = useState(serverSelectedCurrency || selectedCurrencyFromState);

  const urlParams = new URLSearchParams(typeof window === "object" ? window?.location?.search : "");
  const getFiltersArr = urlParams.getAll("filter");
  const fetchData = details?.data || data || [];
  const facetsList = details?.facetDetailList || facetDetailList;
  const hasFacetsList = Array.isArray(facetsList) && facetsList.length > 0;
  const sortOptionsList = details?.sortOptions || sortOptions;
  const localProductTiles = Array.isArray(fetchData) ? [...fetchData] : [];

  // Hook to handle scroll-based visibility for mobile FilterSort component
  const isFilterSortVisible = useScrollVisibility({
    enabled: isMobile && (hasFacetsList || sortOptions) && localProductTiles.length > 0,
  });
  let currentPage = details?.currentPage;
  let totalPages = details?.totalPages || totalPage;

  const totalRenderedProducts = details?.data?.length || localProductTiles.length;
  const totalNoOfProducts = totalProducts || total;
  const filters = getFiltersArr.length > 0 ? getFiltersArr.map((f) => decodeURIComponent(f)) : [];
  const isCapsuleVisible = categoryBanner ? true : false;
  const selectedCountry = selectedIntlCity && JSON.parse(selectedIntlCity);
  const isSmartBuyUser = CookieUtil.getCookie(PARTNER) === HDFC_SMARTBUY;

  bannerTileData?.forEach((banner) => {
    if (Array.isArray(fetchData) && fetchData.length > banner.position - 1) {
      localProductTiles?.splice(banner.position - 1, 0, banner);
    }
  });
  const listingRef = useRef(null);
  const deliveryDatesRef = useRef(deliveryDates);
  deliveryDatesRef.current = deliveryDates;
  const sortLabel =
    sortOptionsList?.find(
      (option) => option.sortBy === sortOption?.sortBy && option.sortOrder === sortOption?.sortOrder,
    )?.level || plpPageConstants.RECOMMENDED;
  const previousPathName =
    typeof window !== "undefined" && document?.referrer ? new URL(document?.referrer)?.pathname : "";
  const completePathName = typeof window !== "undefined" && window.location.href ? window.location.href : "";
  const commonPageData = {
    page_name: pathname,
    page_type: fnpPageType.CATEGORY,
  };

  const duplicateEventData = {
    complete_url: completePathName,
    country: catalogId,
    city: catalogId !== COUNTRIES.INDIA ? selectedIntLocation : null,
    area: catalogId !== COUNTRIES.INDIA ? null : domesticAddress || lastVisitedAddress,
    pincode: catalogId !== COUNTRIES.INDIA ? null : pincode || lastVisitedPincode,
    system_pincode: catalogId !== COUNTRIES.INDIA ? null : pincode || lastVisitedPincode,
    page_name: pathname,
  };
  const pageViewedData = {
    ...commonPageData,
    ...duplicateEventData,
    clean_url: pathname,
    internal_source_type: getPageTypeFromURL(previousPathName),
    internal_source: previousPathName,
    login_status: isUserLoggedIn,
    is_international: catalogId !== COUNTRIES.INDIA,
    plp_category: productCategoryName,
    plp_rating: categoryRatingValue || "",
    plp_review_count: categoryTotalReview,
    total_products: total,
    is_banner_available: !!categoryBanner, // Need to check with Karan for response.
    is_pill_available: hasCapsulePills,
    is_microsite: false,
    is_filter_available: hasFacetsList,
    default_sort: sortLabel,
    experiment_type: campaignId ? campaignId : "",
    user_group: groupName ? groupName : "",
    segment_id: segmentId ? segmentId : "",
    is_smartbuy_user: isSmartBuyUser,
  };

  // The delayed viewed events read this on fire, so they pick up targeting that resolved during the wait.
  const pageViewedDataRef = useRef(pageViewedData);
  pageViewedDataRef.current = pageViewedData;

  /**
   * Filter the available country from the selected international city cookie.
   */
  const filterAvailableCountry = () => {
    if (selectedIntlCity) {
      const availableCity = Object.values(JSON.parse(selectedIntlCity)).find((item) => item.catalogId === catalogId);
      return availableCity ? availableCity : {};
    }
    return "";
  };

  useEffect(() => {
    if (Object.keys(selectedCurrencyFromState).length === 0) {
      if (serverSelectedCurrency?.currency?.id) {
        CookieUtil.setCookie(LOCAL_CURRENCY, serverSelectedCurrency?.currency?.id ?? "", {
          path: "/",
          sameSite: "lax",
          secure: true,
        });
        setCurrencyValue(serverSelectedCurrency);
      }
    } else {
      setCurrencyValue(selectedCurrencyFromState);
    }
  }, [selectedCurrencyFromState]);

  // Fetch delivery dates for SSR products via saga (waits for saved addresses first)
  useEffect(() => {
    const productIds = Array.isArray(data) && data?.length > 0 && data?.map((product) => product?.productId).join(",");

    if (serverSidePincode && productIds) {
      dispatch(requestToFetchInitialPlpServiceabilityAction({ productIds, pincode: serverSidePincode }));
    }
  }, [data, dispatch, serverSidePincode]);

  useEffect(() => {
    if (isDateLoaded) {
      trackEvent(
        plpCleverTapEvents.EARLIEST_DELIVERY_DATE_SHOWN,
        {
          ...commonPageData,
          ...duplicateEventData,
          earliestDatesAvailable: !isEmpty(deliveryDates),
          page_number: currentPage + 1,
        },
        ["clevertap"],
      );
    }
  }, [isDateLoaded]);

  useEffect(() => {
    if (catalogId !== COUNTRIES.INDIA) {
      const country = filterAvailableCountry();
      const options = { maxAge: 60 * 60 * 24 * 7, path: "/", encode: decodeURIComponent };
      if (lastVisitedIntlCity !== country?.cityId) {
        CookieUtil.deleteCookie(LAST_VISITED_INTERNATIONAL_CITY, options);
        CookieUtil.deleteCookie(LAST_VISITED_INTERNATIONAL_LOCATION, options);
        CookieUtil.setCookie(LAST_VISITED_INTERNATIONAL_CITY, country?.cityId || "", options);
        CookieUtil.setCookie(LAST_VISITED_INTERNATIONAL_LOCATION, country?.city || "", options);
      }
    }
    const productElements = document.querySelectorAll("[data-productid]");

    /**
     * Define how to extract product data
     * @param {*} el
     */
    const getProductData = (el) => {
      const productId = el.getAttribute("data-productid");
      const product = localProductTiles.find((item) => item.productId === productId);

      if (!product) {
        return product;
      }

      return {
        ...product,
        deliveryEntry: deliveryDatesRef.current?.[productId] ?? product?.deliveryEntry,
      };
    };

    // 4. Start capturing impressions
    captureImpressions({
      productElements: Array.from(productElements),
      getProductData,
      delayTime: 1500, // Wait 1.5 seconds before logging
      allowDuplicates: false, // Avoid duplicate impressions
      onImpressionsReady: (cdpData) => {
        setImpressionData(cdpData);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set UUID cookie if not present (shared helper with homepage and other SSR → client mirrors).
  useEffect(() => {
    setCookieIfAbsent("ab_user_id", userUUID);
  }, [userUUID]);

  useEffect(() => {
    if (isProductClicked) {
      trackEvent(
        plpCleverTapEvents.PRODUCT_IMPRESSION,
        {
          ...impressionData,
          experiment_type: campaignId ? campaignId : "",
          user_group: groupName ? groupName : "",
          segment_id: segmentId ? segmentId : "",
        },
        ["CDP"],
      );
      clearCapturedImpressions();
    } else if (!isProductClicked && !isEmpty(impressionData)) {
      const timeoutId = setTimeout(() => {
        trackEvent(
          plpCleverTapEvents.PRODUCT_IMPRESSION,
          {
            ...impressionData,
            experiment_type: campaignId ? campaignId : "",
            user_group: groupName ? groupName : "",
            segment_id: segmentId ? segmentId : "",
          },
          ["CDP"],
        );
        clearCapturedImpressions();
      }, 15000);
      return () => clearTimeout(timeoutId);
    }
  }, [isProductClicked, impressionData]);

  useEffect(() => {
    /**
     *  handlePageShow check whether page is served from bfCache
     * @param {*} event
     */
    const handlePageShow = (event) => {
      if (
        event.persisted ||
        (typeof performance !== "undefined" &&
          performance.getEntriesByType?.("navigation")?.[0]?.type === "back_forward")
      ) {
        dispatch(initiateFus());
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    dispatch(setIsMobileSearchVisibleAction(false));
    /**
     * set fnp page type for product listing page
     */
    setListingPageType(categoryId);

    dispatch(
      requestToAddListingDataAction({
        details: fetchFromAPI,
        filters: filters,
        sortOption: sortOption,
      }),
    );

    if (searchQuery) {
      const jsonSelectedIntlCity = JSON.parse(selectedIntlCity);
      if (!isEmpty(jsonSelectedIntlCity) && catalogId !== COUNTRIES.INDIA) {
        const selectedCountriesValues = Object.values(jsonSelectedIntlCity);

        const selectedCountry = selectedCountriesValues.filter((country) => {
          return country.catalogId === catalogId;
        })?.[0];

        dispatch(setSelectedIntLocation({ pincode: selectedCountry?.cityId, location: selectedCountry?.city }));
        dispatch(setSelectedCountryAction(selectedCountry));
      } else if (lastVisitedAddress && lastVisitedPincode) {
        dispatch(setSelectedDomesticLocation({ pincode: lastVisitedPincode, address: lastVisitedAddress }));
      }
    }

    // Initialize analytic tools
    init();
    /**
     *
     * Handles the "CT_web_native_display" event and sets the appropriate state
     * based on the delivery topic.
     *
     * @param {object} event .
     */
    const handleEvent = (event) => {
      if (event.detail.kv.topic === plpBannerConstants.PLP_BANNER) {
        trackEvent(campaignEvents.RENDER_NOTIFICATION_VIEWED, event.detail, ["clevertap"]);
        setPlpBannerData(event.detail.kv);
      }
    };
    document.addEventListener("CT_web_native_display", handleEvent);

    return () => {
      document.removeEventListener("CT_web_native_display", handleEvent);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  useEffect(() => {
    const filteredDuplicateEventData = removeEmptyNullAndUndefinedFromObject(duplicateEventData);

    if (isUserLoggedIn !== undefined) {
      if (!isEmpty(data)) {
        const properties = setGA4ViewItemList(
          data,
          lastVisitedPincode,
          currency,
          isUserLoggedIn,
          categoryId,
          productCategoryName,
          isCapsuleVisible,
          sortOption?.sortBy || "",
          filters,
          catalogId,
          selectedCountry?.[catalogId.toUpperCase()]?.city,
        );
        trackEvent(GA4_EVENTS.VIEW_ITEM_LIST, { ...properties }, ["ga4"]);
        duplicateCleverTapEvents?.[PageTypes.CATEGORY]?.forEach((eventName) => {
          trackEvent(eventName, filteredDuplicateEventData, ["clevertap"]);
        });
      }
    }
  }, [isUserLoggedIn]);

  useEffect(() => {
    if (isUserLoggedIn === undefined || isEmpty(data)) {
      return undefined;
    }

    const pageViewedTimer = setTimeout(() => {
      trackEvent(
        plpCleverTapEvents.PAGE_VIEWED,
        { ...pageViewedDataRef.current, ...buildPartnerMembershipFlags(loginDetail?.partner) },
        ["clevertap"],
      );
    }, PLP_PAGE_VIEWED_DELAY_MS);

    return () => clearTimeout(pageViewedTimer);
  }, [isUserLoggedIn]);

  useEffect(() => {
    const isAnonymous = isUserLoggedIn === false && !emailID;

    if (!(isUserLoggedIn && emailID) && !isAnonymous) {
      return undefined;
    }

    const pageViewedTimer = setTimeout(() => {
      trackEvent(
        plpCleverTapEvents.PAGE_VIEWED,
        { ...pageViewedDataRef.current, ...(isAnonymous ? {} : { user_id: emailID }) },
        ["CDP"],
      );
    }, PLP_PAGE_VIEWED_DELAY_MS);

    return () => clearTimeout(pageViewedTimer);
  }, [isUserLoggedIn, emailID]);

  useEffect(() => {
    if (isMobile) {
      if (!localProductTiles?.length && isLoaded) {
        hideElementsForPLP();
      } else {
        showElementsForPLP();
        playMobilePlpVideo();
      }
    }
  }, [localProductTiles?.length]);

  useEffect(() => {
    dispatch(setIsMobile(isMobile));
    dispatch(setCatalogId(catalogId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);
  /**
   * Fetch more data in infinite scroll using cursor pagination.
   */
  const fetchMoreData = (page) => {
    page = page + 1;
    if (page < totalPages) {
      dispatch(setIsLoaderVisible(true));
      // Get email from faul cookie
      const email = CookieUtil.getCookie("faul") || "";
      const fnpId = CookieUtil.getCookie("ab_user_id");

      const commonPayload = {
        page,
        size: isMobile ? plpPageConstants.MOBILE_PRODUCT_PER_PAGE : plpPageConstants.DESKTOP_PRODUCT_PER_PAGE,
        geoId: catalogId || COUNTRIES?.INDIA,
        pincode: catalogId === COUNTRIES.INDIA ? pincode : intlPincode,
        isLoadMore: true,
        sortBy: appliedSort?.sortBy,
        sortOrder: appliedSort?.sortOrder,
        filters: appliedFilters?.length > 0 ? appliedFilters : [],
        email,
        fnpId,
      };

      const payload =
        categoryId === plpPageConstants?.SEARCH
          ? {
              ...commonPayload,
              pageType: plpPageConstants?.SEARCH,
              qs: encodeURIComponent(searchQuery),
              isOnScroll: true,
            }
          : {
              ...commonPayload,
              categoryUrl: `fnp.com/${categoryId}`,
            };
      dispatch(requestToFetchProductListingAction(removeEmptyNullAndUndefinedFromObject(payload)));
      trackEvent(plpCleverTapEvents.PAGE_SCROLLED, { ...commonPageData, page_number: page }, ["clevertap"]);
    }
  };

  const throtlleNextLoad = throttle((page) => {
    if (isLoaded) fetchMoreData(page);
  }, 400);

  /**
   * This method provides a scroll behavior on click of the global Review Component
   * which in scrolls down to the What customers
   * are saying component
   */
  const onScrollToReviews = () => {
    scrollToSection("reviews-section", 148);
  };

  /** */
  const productClick = debounce((index, product) => {
    setIsProductClicked(true);
    const properties = setGA4SelectedProduct(
      index,
      product,
      pincode,
      currency,
      isUserLoggedIn,
      categoryId,
      productCategoryName,
      isCapsuleVisible,
      filters,
      catalogId,
      selectedCountry?.[catalogId?.toUpperCase()]?.city,
    );
    trackEvent(GA4_EVENTS.SELECT_ITEM, { ...properties }, ["ga4"]);
  }, 100);

  const plpFullBannerData = fullBannerData?.plp;
  const bannerDataObject = {
    banner_image_url: isMobile ? plpFullBannerData?.banner_image_url : plpFullBannerData?.desktop_banner_image_url,
    show_banner: isMobile ? plpFullBannerData?.show_banner : plpFullBannerData?.desktop_show_banner,
    is_full_width: isMobile ? plpFullBannerData?.is_full_width : plpFullBannerData?.desktop_is_full_width,
    category_link: isMobile ? plpFullBannerData?.category_link : plpFullBannerData?.desktop_category_link,
    altTag: "PLP Promotional Banner",
    dimensions: isMobile ? plpFullBannerData?.dimensions : plpFullBannerData?.desktop_dimensions,
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (bannerDataObject?.show_banner) {
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [bannerDataObject?.show_banner]);

  return (
    <div id="mainContent">
      <CursorManager />
      {occasionSpecialEffect?.activeLp?.length > 0 &&
        occasionSpecialEffect?.activeLp?.some((lp) => pathname?.includes(lp)) && (
          <OccasionSpecialEffects isMobile={isMobile} />
        )}
      <OneTapLogin />

      {isNavigating && (
        <div className="fixed inset-0 z-50 mt-[92px] bg-white-900 md:mt-[35px]">
          <PlpSkeleton
            showHeader={true}
            showFilters={true}
            productCount={12}
            isMobile={isMobile}
            hasBanner={catalogId === COUNTRIES.INDIA && !isMobile && Boolean(freeBannerData?.desktop)}
          />
        </div>
      )}

      {catalogId === COUNTRIES.INDIA && isMobile && (
        <FreeDeliveryBannerWrapper
          isMobile={isMobile}
          fromPage={PageTypes.CATEGORY}
          isMicrosite={false}
          bannerData={freeBannerData}
        />
      )}

      {bannerDataObject?.show_banner && (
        <div
          className={`overflow-hidden transition-all duration-1000 ease-out ${
            showBanner ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <SingleImageBannerSection
            category={bannerDataObject}
            isFromSearch={false}
            isMobile={isMobile}
            dimensions={bannerDataObject?.dimensions}
          />
        </div>
      )}
      <div className={`w-full px-16 sm:px-40 ${!localProductTiles.length && isMobile ? "h-[calc(100vh-70%)]" : ""}`}>
        <div itemProp="offers" itemScope itemType="//schema.org/AggregateOffer" className="h-full">
          <div itemScope itemType="//schema.org/Product" className="h-full">
            <link
              itemProp="image"
              content={`${process.env.NEXT_PUBLIC_ASSET_PREFIX}/images/cat/l/${categoryId
                .split("/")
                .map((o) => o.split("-").join(""))
                .join("-")}.jpg`}
            />
            <meta
              itemProp="description"
              content={
                (shortDescription?.replace(Regex.htmlRegularExpression, "")?.trim() &&
                  shortDescription.replace(Regex.htmlRegularExpression, "")) ||
                "Find the best gifts and flowers online at FNP. Explore our wide range of products for every occasion."
              }
            />

            {!isMobile && isShowBreadCrumbs && <Breadcrumb items={breadcrumbs} catalogId={catalogId} />}
            <div
              className={`flex gap-16 py-16 ${!localProductTiles.length ? "h-full" : ""} ${isShowBreadCrumbs ? "md:pt-0" : "md:pt-24"}`}
            >
              {hasFacetsList && !isMobile && (
                <div className="w-1/5 pb-16">
                  <ProductFilter facets={facetsList} categoryId={categoryId} />
                </div>
              )}
              <div className={`${!isMobile && hasFacetsList ? "w-4/5" : "w-full"}`}>
                {Array.isArray(parsedPlpBanners) && parsedPlpBanners.length ? (
                  <CarouselContainer bannerList={parsedPlpBanners} />
                ) : null}
                {!isMobile && localProductTiles.length ? (
                  <PlpTitleRowDesktop
                    isMobile={isMobile}
                    facetFilter={facetsList}
                    sortData={sortOptions}
                    bestRating={categoryRatingValue}
                    productCategoryName={productCategoryName || searchQuery}
                    totalProducts={totalProducts || total}
                    productList={Array.isArray(fetchData) ? fetchData.length : 0}
                    reviewCount={categoryTotalReview}
                    onScrollToReviews={onScrollToReviews}
                    categoryId={categoryId}
                    isLoaded={isLoaded}
                    plpATF={plpATF}
                  />
                ) : (
                  <></>
                )}
                {!isEmpty(plpBannerData) && localProductTiles.length ? (
                  <PlpBanner isMobile={isMobile} plpBannerData={plpBannerData} />
                ) : (
                  <></>
                )}
                {(hasCapsulePills || categoryBanner) && localProductTiles.length ? (
                  <QuickLinks
                    isMobile={isMobile}
                    dataList={hasCapsulePills ? parsedCapsulesData : null}
                    fallbackHTML={categoryBanner}
                  />
                ) : (
                  <></>
                )}
                {isMobile && (
                  <PlpTitleRowMobile
                    productCategoryName={productCategoryName}
                    searchQuery={searchQuery}
                    totalRenderedProducts={totalRenderedProducts}
                    totalNoOfProducts={totalNoOfProducts}
                  />
                )}

                {isMobile && localProductTiles.length ? (
                  <FilterChips hasFacetsList={hasFacetsList} chipData={facetsList} />
                ) : null}

                {localProductTiles?.length ? (
                  <InfiniteScroll
                    currentPage={currentPage + 1}
                    totalPages={totalPages}
                    getMoreData={() => throtlleNextLoad(currentPage)}
                    containerRef={listingRef}
                  >
                    <div
                      id="plpProduct"
                      className={formatClassNames("flex flex-wrap items-stretch gap-16", isMobile && "pt-8")}
                      ref={listingRef}
                    >
                      {localProductTiles?.map((product, index) => {
                        const isLastItem = index === localProductTiles.length - 1;
                        const shouldRenderCleverTap = index === 19 || (localProductTiles?.length <= 19 && isLastItem);
                        return (
                          <React.Fragment key={`Listing-Card-${index}`}>
                            {product.productId ? (
                              <div
                                className={
                                  !isMobile
                                    ? hasFacetsList
                                      ? isPlpRevampTiles
                                        ? "w-[calc(33%-8px)]"
                                        : "w-[calc(24.5%-8px)] xmll:w-[calc(24.6%-8px)] xll:w-[calc(24.6%-8px)]"
                                      : isPlpRevampTiles
                                        ? "w-[calc(24.7%-8px)]"
                                        : "w-[calc(19.5%-8px)] xll:w-[calc(19.7%-8px)]"
                                    : "w-[calc(50%-8px)]"
                                }
                                key={`Card-${product?.productId}_${index}`}
                                onClick={() => productClick(index, product)}
                              >
                                <ProductCard
                                  isMobile={isMobile}
                                  image={product?.productImage}
                                  title={product?.brandName || product?.productName}
                                  price={product?.price}
                                  imgHeight={500}
                                  productWidget={product}
                                  imgWidth={500}
                                  isPriority={index < 4 ? true : false}
                                  review={product?.rating}
                                  productId={product?.productId}
                                  productUrl={product?.productUrl}
                                  imageCount={product?.imageCount}
                                  urlIdentifier={product?.urlIdentifier}
                                  category={product?.fnpProductType}
                                  productAttributes={getDisplayTags(
                                    productsAttrTagData,
                                    product?.["productAttributes"],
                                  )}
                                  isSmallReviewTag={isMobile}
                                  deliveryEntry={deliveryDates?.[product?.productId]}
                                  isDeliveryTimeHidden={isCardDeliveryTimeHidden}
                                  experiment={{ campaignId, segmentId, groupName }}
                                  pincode={catalogId === COUNTRIES.INDIA ? pincode : intlPincode}
                                  skuCode={product?.sku}
                                  isPlpRevampTiles={isPlpRevampTiles}
                                  isLoaded={isLoaded}
                                  serverSelectedCurrency={currencyValue}
                                />
                              </div>
                            ) : (
                              <div
                                className={
                                  !isMobile
                                    ? hasFacetsList
                                      ? isPlpRevampTiles
                                        ? "relative w-[calc(33%-8px)]"
                                        : "relative w-[calc(24.5%-8px)]"
                                      : isPlpRevampTiles
                                        ? "relative w-[calc(24.7%-8px)]"
                                        : "relative w-[calc(19.5%-8px)]"
                                    : "relative w-[calc(50%-8px)]"
                                }
                                key={`Banner-${index}`}
                              >
                                <PLPBannerTile
                                  tileData={product}
                                  isPriority={index < 4 ? true : false}
                                  isLargeTiles={isPlpRevampTiles}
                                />
                              </div>
                            )}
                            {shouldRenderCleverTap && (
                              <CleverTapWidget
                                fromPage={PageTypes?.CATEGORY}
                                isMobile={isMobile}
                                slidesToShow={!hasFacetsList}
                              />
                            )}

                            {index ===
                              (isMobile
                                ? (localProductTiles.length < plpPageConstants.MOBILE_PRODUCT_PER_PAGE
                                    ? localProductTiles.length
                                    : plpPageConstants.MOBILE_PRODUCT_PER_PAGE) - 1
                                : (localProductTiles.length < plpPageConstants.DESKTOP_PRODUCT_PER_PAGE
                                    ? localProductTiles.length
                                    : plpPageConstants.DESKTOP_PRODUCT_PER_PAGE) - 1) &&
                              !isEmpty(reviewResponse?.data) && (
                                <CustomerReviewsCarousel
                                  key={`Review-${product?.productId}_${index}`}
                                  reviews={reviewResponse?.data}
                                  title={TESTIMONIAL_TITLE}
                                  totalReviews={reviewResponse?.total}
                                  pageType={typeof window !== "undefined" ? window.fnpPageType : ""}
                                  categoryId={categoryId}
                                  isMobile={isMobile}
                                  mobileCarouselParentStyle=""
                                  viewAllStyle="pr-0 md:pr-16"
                                  ratingValue={categoryRatingValue}
                                  isFromPLP={true}
                                  productName={productCategoryName}
                                />
                              )}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </InfiniteScroll>
                ) : isLoaded && !localProductTiles.length ? (
                  <ProductNotFoundWrapper />
                ) : (
                  <LottieLoader isBackDrop={false} />
                )}
                <CountOnScroll totalRenderedProducts={totalRenderedProducts} totalNoOfProducts={totalNoOfProducts} />
              </div>
            </div>
            {isMobile && isShowBreadCrumbs && localProductTiles.length ? (
              <Breadcrumb items={breadcrumbs} catalogId={catalogId} />
            ) : null}
          </div>
        </div>
      </div>
      {(hasFacetsList || sortOptions) && isMobile && localProductTiles.length ? (
        <div
          className={`border-grey-25 fixed bottom-0 flex w-full bg-white-900 transition-transform duration-300 ease-in-out ${
            isFilterSortVisible ? "" : "translate-y-full"
          } ${isShowMobileLocationLockDrawer || isShowMobileLocationLock || isCurrencyDrawerVisible || isMobileSearchDrawerVisible ? "z-40" : "z-50"}`}
        >
          <FilterSort facetFilter={facetsList} sortData={sortOptions} categoryId={categoryId} />
        </div>
      ) : null}
      <CommonConditionalComponents isMobile={isMobile} />
      {isShowCartEmpty && <ClearCart isMobile={isMobile} selectedCurrency={selectedCurrencyFromState} />}
    </div>
  );
};

ProductListingPage.propTypes = {
  fetchFromAPI: PropTypes.object.isRequired,
  sortOption: PropTypes.object,
  reviewResponse: PropTypes.object.isRequired,
  breadcrumbs: PropTypes.array.isRequired,
  categoryBanner: PropTypes.string,
  plpBanners: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  plpPromotionalBanners: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  capsulesData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isMobile: PropTypes.bool.isRequired,
  categoryId: PropTypes.string.isRequired,
  shortDescription: PropTypes.string,
  catalogId: PropTypes.string.isRequired,
  isShowBreadCrumbs: PropTypes.bool,
  searchQuery: PropTypes.string,
  userUUID: PropTypes.string,
  isPlpRevampTiles: PropTypes.bool,
  serverSidePincode: PropTypes.string,
  freeBannerData: PropTypes.object,
  plpATF: PropTypes.string,
  serverSelectedCurrency: PropTypes.object,
};
